import { isSuccessStatusCode } from 'owa-http-status-codes';
import { makeGetRequest } from 'owa-ows-gateway';
import { EcsTelemetrySettings } from '../types/EcsTelemetrySettingTypes';

const telemetrySettingsUrl = 'ows/v1.0/TelemetrySettings/clientsettings';

export default async function getEcsTelemetrySettings(): Promise<EcsTelemetrySettings | null> {
    // Make server call
    const response = await makeGetRequest(
        telemetrySettingsUrl,
        undefined /* correlationId */,
        true /* returnFullResponse */,
        undefined /* customHeaders */,
        undefined /* throwServiceError */,
        undefined /* includeCredentials */,
        'getTelemetrySettings' /* actionName */
    );

    if (isSuccessStatusCode(response.status)) {
        return response.json();
    }

    return null;
}
